import "./Post.scss"
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import FavoriteOutlinedIcon from "@mui/icons-material/FavoriteOutlined";
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Link } from "react-router-dom";
import Comments from "../comments/Comments";
import { useContext, useState } from "react";
import moment from "moment";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { makeRequest } from "../../axios";
import { AuthContext } from "../../context/authContext";

const Post = ({post, userProfilePic}) => {

    const [commentOpen, setCommentOpen] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);


    const {currentUser} = useContext(AuthContext)

    const { isLoading, error, data } = useQuery(["likes", post.id], () =>
    makeRequest.get("/likes?postId=" + post.id).then((res) => {
      return res.data;
    }));

  const queryClient = useQueryClient();

  const mutation = useMutation(
    (liked)=>{
        if (liked) return makeRequest.delete("/likes?postId=" + post.id);
        return makeRequest.post("/likes", { postId: post.id });
  }, {
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries(["likes"]);
    },
  });

  const deleteMutation = useMutation(
    (postId) => {
      return makeRequest.delete("/posts/" + postId);
    },
    {
      onSuccess: () => {
        // Invalidate and refetch
        queryClient.invalidateQueries(["posts"]);
      },
    }
  );

  const handleLike = () => {
    mutation.mutate(data.includes(currentUser.id));
  };

  const handleDelete = () => {
    deleteMutation.mutate(post.id);
  };

  return (
    <div className="post">
        <div className="container">
            <div className="user">
                <div className="userInfo">
                    <div className="details">
                        <Link to={`/profile/${post.userId}`} style={{textDecoration:"none", color:"inherit"}}>
                            <span className="name">{post.username}</span>
                        </Link>
                        <span className="date">{moment(post.createdAt).fromNow()}</span>
                    </div>
                </div>
                {post.userId === currentUser.id && (
                <MoreHorizIcon onClick={() => setMenuOpen(!menuOpen)} />
                )}
                {menuOpen && post.userId === currentUser.id && (
              <button onClick={handleDelete}>delete</button>)}
            </div>
            <div className="content">
                <p>{post.desc}</p>
                <img src={"https://loop-be.onrender.com/uploads/"+ post.img} alt=""/>
            </div>
            <hr className="postHr"/>
            <div className="info">
                <div className="item">
                    {isLoading ? "loading" : data && data.includes(currentUser.id) ? (<FavoriteOutlinedIcon style={{color: "red"}} onClick={handleLike}/>) : (<FavoriteBorderOutlinedIcon onClick={handleLike}/>)} 
                    {data ? data.length: 0} Likes
                </div>
                <div className="item" onClick={()=>setCommentOpen(!commentOpen)}>
                    <SmsOutlinedIcon/>
                    Comments
                </div>
            </div>
            {commentOpen && <Comments postId={post.id}/>}
        </div>
    </div>
  )
}

export default Post